import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useViewport } from '@/hooks';
import { SquareStackIcon } from '@/icons';
import { IconButton, Tooltip } from '@/ui_v3';
import { useIsQuestionCardAiTarget } from '../../../features/question-card-ai/hooks/useIsQuestionCardAiTarget';
import { useQuizList } from '../../useQuizList';
import { useQuizControl } from '../QuizControlProvider';
export const QuizDuplicateButton = ({
  disabled
}: {
  disabled?: boolean;
}) => {
  const {
    t
  } = useTranslation(['common', 'build']);
  const {
    isMobile
  } = useViewport();
  const {
    handleCopy
  } = useQuizList();
  const {
    id,
    index
  } = useQuizControl();
  // 이 카드가 AI 작업의 원본이면 끝날 때까지 복제·삭제를 잠근다(결과 폐기·리비전 꼬임 방지).
  const isAiTarget = useIsQuestionCardAiTarget(id);
  const isDisabled = disabled || isAiTarget;
  return <Tooltip.Provider disableHoverableContent={isMobile} data-sentry-element="unknown" data-sentry-component="QuizDuplicateButton" data-sentry-source-file="QuizDuplicateButton.tsx">
      <Tooltip.Root data-sentry-element="unknown" data-sentry-source-file="QuizDuplicateButton.tsx">
        <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="QuizDuplicateButton.tsx">
          <IconButton size="xs" variant="outlined" intent="neutral" className="hidden mobile-lg:flex" disabled={isDisabled} onMouseDown={e => {
          e.preventDefault();
          e.stopPropagation();
        }} onClick={() => {
          handleCopy(index);
          logger.track('copy_quizItem', {
            position: 'card_button'
          });
        }} data-sentry-element="IconButton" data-sentry-source-file="QuizDuplicateButton.tsx">
            <SquareStackIcon size="xs" fill={isDisabled ? ICON_COLOR.disabled : ICON_COLOR.default} data-sentry-element="SquareStackIcon" data-sentry-source-file="QuizDuplicateButton.tsx" />
          </IconButton>
        </Tooltip.Trigger>
        <Tooltip.Content data-sentry-element="unknown" data-sentry-source-file="QuizDuplicateButton.tsx">{t('global.duplicate.button')}</Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>;
};